import { ROOT_DIR_ID } from 'shared/constants/directory';

/** Directory id with `null` / `undefined` treated as the documentation root. */
export function normalizeDirectoryId(id: string | null | undefined): string {
  return id ?? ROOT_DIR_ID;
}

/**
 * Whether two directory ids point to the same directory. The root is the
 * `ROOT_DIR_ID` sentinel (not an ObjectId), so ObjectId helpers do not apply.
 */
export function areDirectoryIdsEqual(
  a: string | null | undefined,
  b: string | null | undefined
): boolean {
  return normalizeDirectoryId(a) === normalizeDirectoryId(b);
}

export function isRootDirectory(id: string | null | undefined): boolean {
  return normalizeDirectoryId(id) === ROOT_DIR_ID;
}
